import f1 from "assets/images/posts/f1.jpg";
import f2 from "assets/images/posts/f2.jpg";
import PostImage from "./PostImage";

const PostMedia2 = () => {
    return (
        <div className="post-image double-img">
            <div className="masonry-grid justify-center gap-5">
                {/* <!-- Left column --> */}
                <div className="masonry-column-left " style={{ width: "45%" }}>
                    <PostImage img={f1} />
                </div>
                {/* <!-- Right column --> */}
                <div className="masonry-column-right " style={{ width: "45%" }}>
                    <PostImage img={f2} />
                </div>
            </div>
        </div>
    );
};

export default PostMedia2;
